module.exports = __webpack_public_path__ + "static/media/conectogo-logo.a5c57120.png";